module.exports = __webpack_public_path__ + "img/icon_villa-management.2bdcffe6.svg";